import { render, staticRenderFns } from "./swiperNav.vue?vue&type=template&id=d5880f5e&scoped=true&"
import script from "./swiperNav.vue?vue&type=script&lang=js&"
export * from "./swiperNav.vue?vue&type=script&lang=js&"
import style0 from "./swiperNav.vue?vue&type=style&index=0&id=d5880f5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5880f5e",
  null
  
)

export default component.exports